import React, { useState } from 'react';
import axios, { AxiosError } from 'axios';
import CssBaseline from '@material-ui/core/CssBaseline';
import PrimarySearchAppBar from '../components/Appbar'
import Helmet from 'react-helmet';
import {
    Avatar, Badge, Box, Button, CircularProgress, Container, Dialog, DialogActions,
    DialogContentText, FormControl, Grid, InputLabel, makeStyles, Menu, MenuItem, Select,
    Tab,
    Tabs,
    TextField, Tooltip, Typography
} from '@material-ui/core';
import ModelCard from '../components/ModelCard';
import QuickEdit from '../components/quickEdit';
import EditAppBar from '../components/EditAppbar';
import { useSnackbar } from 'notistack';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import DownloadIcon from '@material-ui/icons/GetApp';
import ReceiptIcon from '@material-ui/icons/Receipt';
import IconButton from '@material-ui/core/IconButton';
import { BulkEditOrbit, deleteAll, GetColor, SubmitEdits } from "../util/listFunctions";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PaletteIcon from '@material-ui/icons/Palette';
import Colors from '../util/BGColors';
import { catFacts, Licences } from "../util/HardCodedLists";
import SimplePopup from '../components/SimplePopup';
import SimpleConfirm from '../components/SimpleConfirm';
import { Link, RouteComponentProps } from 'react-router-dom';
import { modelCardProps } from '../types/modelcard';
import DisplayAxiosError from '../util/DisplayAxiosError';
import MUILink from '@material-ui/core/Link'
import { useForm } from 'react-hook-form';
import BundleEdit from '../components/BundleEdit';
// import CarbonAds from '../components/carbonAds';
import ListEdit from '../components/ListEdit';
import CreatorInfo from '../components/CreatorInfo';
import ListAttributionPopup from '../components/ListAttribution';
import { ModelBundle } from '../types/List';
import GetAppIcon from '@material-ui/icons/GetApp';
import GetBundleURL from '../util/GetBundleURL';
import GetModelSource from '../util/GetModelSrc';

function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    removeButton: {
        position: 'absolute',
        top: '5px',
        right: '5px',
    },
}));

let currentUser;

interface propTypes {
    list: ModelBundle;
    editMode: boolean;
    isLoggedIn: boolean;
    history: RouteComponentProps["history"];
    isLoading: any;
    modelData: { ResourceID: string; }[];
}


const ListView = (props: propTypes) => {

    const classes = useStyles();

    const [ListModels, setModels] = useState(props.list.Models);
    const [orbitOpen, setOrbitOpen] = useState(true);
    const [orbitIndex, setOrbitIndex] = useState(0);
    const [formDatas, setformDatas] = useState([]);
    const [bgIndex, setbgIndex] = useState(getRandomInt(Colors.Solid.length))
    const [bgCol, setBgCol] = useState(GetColor(bgIndex));
    const [autoTagLoading, setAutoTagLoading] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [factIndex, setfactIndex] = useState(getRandomInt(catFacts.length));

    const [AttributionState, setAttributionState] = useState(false);

    const [canEditList, setCanEdit] = useState(false);
    const [allMyModels, setAllModels] = useState(false);
    const [listName, setListName] = useState(props.list.Name);

    const [menuEl, setMenuEl] = React.useState<null | HTMLElement>(null);
    const handleMenuClose = () => { setMenuEl(null); };

    const [deleteListDialogOpen, setdeleteListDialogOpen] = useState(false);


    const { register, handleSubmit, control, errors, clearErrors } = useForm({ mode: 'onChange', shouldUnregister: false });

    //Get initial featured asset from reverse lookup of public id 
    const [featuredIndex, setfeaturedIndex] = useState(props.list.Models.findIndex(x => x.publicID === props.list.FeaturedAsset?.PublicID));

    const [tabIndex, setTabIndex] = React.useState(0);

    //set inital state for quick edit forms
    React.useEffect(() => {

        console.log(props.list.Models.findIndex(x => x.publicID === props.list.PublicID));

        //Check for place all param
        const urlParams = new URLSearchParams(window.location.search);
        setOrbitOpen(urlParams.get('placeall') !== null);

        //For cat facts.
        if (props.editMode) {
            setTimeout(() => {
                setfactIndex(getRandomInt(catFacts.length));
            }, 5000);
        }

        //Get logged in user info to compare to list owner
        currentUser = JSON.parse(localStorage.getItem('user'));
        if (currentUser && authed) {
            setCanEdit(currentUser && (currentUser.publicID == props.list.Owner.Username || currentUser.publicID == 'dook'));

            //Check if all models are owned by current user
            let allMyModels = true;
            props.list.Models.forEach(model => {
                if (model.creator.username !== currentUser.publicID) {
                    allMyModels = false;
                }
            });
            setAllModels(allMyModels);
        }
        else {
            setCanEdit(false);
            setAllModels(false);
        }

    }, []);

    React.useEffect(() => setBgCol(GetColor(bgIndex)), [bgIndex]); //update bg color

    //Edit callback from bulk forms
    function editForm(index, modelData) {
        let data = formDatas;
        data[index] = modelData;
        setformDatas(data);
    }

    function removeFromList(index) {
        let data = [...formDatas];
        data.splice(index, 1);
        setformDatas(data);

        let models = [...ListModels];
        models.splice(index, 1);
        setModels(models);
    }

    async function DownloadAll(format: string) {
        //must be logged in
        // if (!props.isLoggedIn) {
        //     enqueueSnackbar("You must be logged in to do that", { variant: 'info', });
        //     return;
        // }

        //Must donate to download more than X (TODO personal lists only)
        if (props.list.Models.length > 50) {
            const isSupporter = await axios.get('/api/me/isSupporter');
            if (!isSupporter) {
                setdonationDialog(true);
                return;
            }
        }

        setAttributionState(true);

        axios.get(`/api/list/${props.list.PublicID}/download/${format}`, { withCredentials: true, responseType: 'blob' }).then(async (response) => {

            let url = window.URL.createObjectURL(new Blob([response.data]));

            //override url if it's cached (server returns a json with link to s3 instead of blob)
            if (response.data.type === 'application/json') {
                let file = new Blob([response.data], { type: 'application/json' });
                const json = await file.text();
                url = JSON.parse(json).url;
            }

            //first time dl
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${props.list.Name}.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }).catch((e) => {
            DisplayAxiosError(e, enqueueSnackbar);
        });

        /* @ts-ignore*/
        umami.track('Download List', { list: props.list.PublicID });
        // window.plausible('Download List', { props: { list: props.list.PublicID } });
    }

    async function Save() {
        //Submit pack edit stuff
        const onSubmit = async (bundleData) => {
            // console.log(bundleData);
            await SubmitEdits(formDatas, enqueueSnackbar, props.history, props.list.PublicID, featuredIndex, bundleData); //submit model edits
            setTabIndex(0);
        }
        const onError = (error) => { setTabIndex(1); }

        handleSubmit(onSubmit, onError)();
    }

    return (
        <React.Fragment>
            <CssBaseline />

            <Helmet><title>{`${props.list.Name} Collection by ${props.list.Owner.Username} - Poly Pizza`}</title></Helmet>
            {
                !props.editMode ?
                    <PrimarySearchAppBar loggedIn={props.isLoggedIn} history={props.history} isLoading={props.isLoading} /> :
                    <EditAppBar history={props.history} onSave={Save} title={"Edit Bundle"}></EditAppBar>
            }

            <Container maxWidth="xl" className='pt-4'>
                {/* Icon buttons */}
                <div className='flex justify-between pb-[1vh]'>
                    <div className="flex items-center gap-1">
                        {!props.editMode && <Typography variant="h4">{props.list.Name}</Typography>}

                        {/* In edit mode creator can delete all models */}
                        {props.editMode && allMyModels &&
                            <Tooltip title="Delete Models" placement="top">
                                <IconButton aria-label="Delete all models" onClick={() => setConfirmOpen(true)} >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {/* user edits list */}
                        {!props.editMode && canEditList &&
                            <Tooltip title="Edit List" placement="top">
                                <IconButton href={'?edit'} >
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {/* user deletes list */}
                        {!props.editMode && canEditList &&
                            <Tooltip title="Delete List" placement="top">
                                <IconButton onClick={() => setdeleteListDialogOpen(true)} >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {/* Normal List Functions */}
                        {!props.editMode &&
                            <React.Fragment>
                                <Tooltip title="Download All" placement="top">
                                    <IconButton onClick={(e) => setMenuEl(e.currentTarget)} >
                                        <DownloadIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Attribution" placement="top">
                                    <IconButton to={props.history.location.pathname + '/credits'} component={Link}>
                                        <ReceiptIcon />
                                    </IconButton>
                                </Tooltip>
                            </React.Fragment>
                        }
                    </div>

                    {!props.editMode && <CreatorInfo Creator={props.list.Owner} />}
                </div>
                {/* Tab bar */}
                {props.editMode && <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className='bg-gray-dark rounded-md mb-4'>
                    <Tabs value={tabIndex} indicatorColor="primary" textColor="primary" onChange={(e, value) => setTabIndex(value)}>
                        <Tab label="Models" />
                        <Tab label="Details" />
                    </Tabs>
                </Box>}

                {/* Normal model edit screen */}

                <ListEdit
                    modelData={props.modelData}
                    ListModels={ListModels}
                    editMode={props.editMode}
                    removeButtClass={classes.removeButton}
                    removeFromList={removeFromList}
                    editForm={editForm}
                    currentUser={currentUser}
                    featuredIndex={featuredIndex}
                    setfeaturedIndex={setfeaturedIndex}
                    visible={tabIndex == 0}
                />

                <BundleEdit
                    visible={tabIndex == 1}
                    errors={errors}
                    register={register}
                    control={control}
                    enqueueSnackbar={enqueueSnackbar}
                    list={props.list}
                    history={props.history}
                />


            </Container>

            <Dialog
                open={orbitOpen}
                maxWidth={false}
            >
                {/* @ts-ignore */}
                <model-viewer
                    id="positioner"
                    environment-image="/static/HDR/BG.hdr"
                    //class={`${classes.model} noMenu`}
                    src={props.editMode && props.modelData.length > 0 ? GetModelSource(props.modelData[orbitIndex].ResourceID) : false}
                    camera-controls
                    shadow-intensity="1"
                    interaction-prompt="none"
                    loading="eager"
                    disable-zoom
                    style={{ background: `radial-gradient(circle, ${bgCol.one} 20%, ${bgCol.two} 120%)`, width: '50vw', height: '60vh' }}
                ></model-viewer>

                <DialogActions style={{ justifyContent: 'space-between' }}>

                    <div>
                        <IconButton onClick={() => setbgIndex((bgIndex + 1) % Colors.Solid.length)}>
                            <PaletteIcon />
                        </IconButton>
                        <IconButton onClick={() => setOrbitIndex((orbitIndex + 1) % props.modelData.length)}>
                            <ArrowForwardIcon />
                        </IconButton>

                    </div>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => BulkEditOrbit(props.list.PublicID, setOrbitOpen, setAutoTagLoading, bgCol)}
                    >
                        Set all orbits
                    </Button>

                </DialogActions>
            </Dialog>

            <SimplePopup
                //handleClose={() => setAutoTagLoading(false)}
                open={autoTagLoading}
                //closeText="cool"
                title="Processing your models"
                body={
                    <React.Fragment>
                        <DialogContentText color="textPrimary"> While you wait, please enjoy some cat facts!</DialogContentText>
                        <div style={{ padding: '30px' }}>
                            <Typography variant="h6" color="textPrimary" style={{ textAlign: 'center' }}>
                                {catFacts[factIndex]}
                            </Typography>
                        </div>
                        <div style={{ width: '20vw', display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress />
                        </div>
                        <Typography variant="body2" style={{ textAlign: 'left' }}> Source: Me, after 2 beers</Typography>
                    </React.Fragment>
                }
            />

            <SimpleConfirm
                open={deleteListDialogOpen}
                setOpen={setdeleteListDialogOpen}
                title={'Delete this list?'}
                content={"Are you sure you want to delete this list? This can't be undone."}
                destructive
                action={() => {
                    axios.delete(`/api/list/${props.list.PublicID}`).then(() => {
                        enqueueSnackbar('List deleted', { variant: 'success' });
                        props.history.push('/');
                    }
                    ).catch((err) => {
                        enqueueSnackbar('Failed to delete list', { variant: 'error' });
                    })
                }}
            />

            <ListAttributionPopup
                handleClose={() => { setAttributionState(false) }}
                snackbar={enqueueSnackbar}
                open={AttributionState}
                list={props.list}
            />

            {/*Download menu*/}
            <Menu
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                open={Boolean(menuEl)}
                anchorEl={menuEl}
                onClose={handleMenuClose}
            >
                <MenuItem
                    onClick={() => DownloadAll('zip')}
                    className={'pr-12'}>
                    <GetAppIcon className={'text-gray-button m-2'} />
                    Download FBX/OBJ
                </MenuItem>
                <MenuItem
                    onClick={() => DownloadAll('glb')}
                    className={'pr-12'}>
                    <GetAppIcon className={'text-gray-button m-2'} />
                    Download GLB
                </MenuItem>
            </Menu>

        </React.Fragment>
    );
}


ListView.getInitialProps = async ({ req, res, match, history, location, ...ctx }) => {

    let listResp;
    try {
        listResp = await axios.get(`${process.env.SITE_ROOT}/api/list/${match.params.id}`);
    } catch (e) {
        return { statusCode: e.response?.status ?? 404 };
    }
    let url: string = req !== undefined ? req.originalUrl : match.url;
    const editMode = url.includes('edit') || url.includes('placeall');

    //redirect if list is a bundle
    if (listResp.data.Description && !editMode) {
        return { redirectTo: GetBundleURL(listResp.data.Name, match.params.id) }
    }

    // let promises = []
    let models = [];

    // @ts-ignore
    const isLoggedIn = req !== undefined ? ctx.authed : authed;  //if SSR, use authed from context, otherwise use local var;
    if (editMode) //if edit get full details for all models
    {
        //TODO check ownership - any authed user can get to the edit page but won't be able to actually change shit
        if (!isLoggedIn) return { statusCode: 404 };

        //Get individual model data (TOO SLOW)
        // for (let i = 0; i < listResp.data.Models.length; i++) {
        //     const model = listResp.data.Models[i];
        //     const url = model.url.split('/')[2];
        //     promises.push(axios.get(`${process.env.SITE_ROOT}/api/model/${url}/details`).then((d) => models[i] = d.data));
        // }

        let modelResp = await axios.get(`${process.env.SITE_ROOT}/api/list/${match.params.id}/details`);
        models = modelResp.data;
    }
    // await Promise.all(promises);

    return { isLoggedIn, list: listResp.data, modelData: models, editMode, darkMode: ctx.darkMode }
}

export default ListView;